<template>
  <nx-fullscreen-dialog
      :active="active"
      :title="$t('message.wizard.navigation.edit')"
      @dismiss="$emit('dismiss')">

    <template slot="toolbar-items">
      <v-btn
          @click="create"
          color="accent"
          dark flat
          v-html="$t('message.common.accept')"
          :disabled="!flags.valid"
      ></v-btn>
    </template>

    <v-container py-3 fluid class="nx-navigation-wizard-body" v-if="active">
      <v-layout>
        <v-flex class="xs12 sm10 offset-sm1 md8 offset-md2">
          <component
              :is="formConfig.component"
              v-if="formConfig.component"
              v-bind="formConfig.props"
              :parent-node="parentNode"
              :value="draft"
              @input="updateField"
              @form="flags = $event"
          ></component>
          <nx-form-generator-scope
              v-else-if="draft"
              :config="formConfig"
              :show-tabs="false"
              :value="draft"
              @input="updateField"
              @form="flags = $event"
              ref="form"
          ></nx-form-generator-scope>
        </v-flex>
      </v-layout>
    </v-container>

  </nx-fullscreen-dialog>
</template>

<script>
import Form from '@/modules/form/Form';
import FormText from '@/modules/form/components/FormText';
import FullscreenDialog from '@/components/dialogs/FullscreenDialog';
import cloneDeep from 'lodash/cloneDeep';
import BoardFormSelector from '@/modules/board/selector/Selector';
import ContentSelector from '@/modules/content/selector/Selector';
import TagSelector from '@/modules/taxonomy/selector/TagSelector';
import TaxonomySelector from '@/modules/taxonomy/selector/Selector';
import NxFormNavigationUrl from '@/modules/navigation/components/FormNavigationUrl';
import NxFormGeneratorScope from '@/modules/form/FormScopeGenerator';

export default {
  name: 'nx-navigation-wizard',
  $_veeValidate: {
    validator: 'new', // give me a new vee-validate instance each time.
  },
  components: {
    NxFormGeneratorScope,
    NxFormNavigationUrl,
    [TaxonomySelector.name]: TaxonomySelector,
    [TagSelector.name]: TagSelector,
    [ContentSelector.name]: ContentSelector,
    [BoardFormSelector.name]: BoardFormSelector,
    [Form.name]: Form,
    [FormText.name]: FormText,
    [FullscreenDialog.name]: FullscreenDialog,
  },
  props: {
    active: Boolean,
    formConfig: [Object, Array],
    parentNode: Object,
    value: Object,
  },
  data() {
    return {
      draft: {},
      flags: {},
      type: 'manual',
      entity: null,
      target: false,
    };
  },
  computed: {},
  methods: {
    updateField(field, value) {
      console.log('%c[Navigation Wizard]', 'color:purple', field, value);
      this.$set(this.draft, field, value);
    },
    create() {
      if (this.target) {
        this.draft.target = '_blank';
      } else {
        delete this.draft.target;
      }
      this.draft.type = this.type === 'separator' ? 'separator' : 'link';
      this.$emit('input', this.draft);
    },
    setDraft() {
      this.target = !!this.value.target;
      this.entity = null;
      this.type = 'manual';
      if (this.value) {
        this.draft = cloneDeep(this.value);
      } else {
        this.draft = {};
      }
    },
  },
  watch: {
    active() {
      this.setDraft();
    },
  },
};
</script>
